import styled from 'styled-components';

export const Blur = styled.div`
  ${({ isBlurred }) =>
    isBlurred &&
    `
    filter: blur(5px);
    pointer-events: none;
    user-select: none;
  `}
  transition: filter 0.3s ease;
`;
